import { Suspense, lazy } from "react";
import { Provider } from "react-redux";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import Footer from "./components/HeaderFooter/Footer";
import Header from "./components/HeaderFooter/Header";
import ScrollToTop from "./components/ScrollToTop";
import SearchPopup from "./components/SearchPopup";
import ThemeToggle from "./components/ThemeToggle";
import AuthFooter from "./Pages/Auth/AuthFooter";
import { store } from "./redux/store";
import ProtectedRouter from "./routes/ProtectedRouter";
import ProtectedRouterLogin from "./routes/ProtectedRouterLogin";
import OrderHistory from "./Pages/History/OrderHistory";
import { routeMetadata } from "./routes/metadata";
import { HelmetProvider } from "react-helmet-async";
import Kyc_Terms_conditions from "./Pages/KycTerms&conditions ";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
// import Privacy from "./Pages/Privacy";
// import Terms_conditions from "./Pages/Terms&conditions";

import { ToastContainer } from "react-toastify";
import Convert from "./Pages/Convert";
import ConvertHistory from "./Pages/ConvertHistory";
import Referral from "./Pages/Referral";
import consts from "./constant";
import AutoLogout from "./AutoLogout";
import IPVerification from "./IPVerification";
import OtpValidationEmail from "./Pages/Auth/OtpValidationEmail";
// Lazy Load Pages
const Home = lazy(() => import("./Pages/Home/Home"));
const Login = lazy(() => import("./Pages/Auth/Login"));
const Register = lazy(() => import("./Pages/Auth/Register"));
const Stake = lazy(() => import("./Pages/Stake"));
const Wallet = lazy(() => import("./Pages/Wallet"));
const Profile = lazy(() => import("./Pages/Profile"));
const Notification = lazy(() => import("./Pages/Notification"));
const Support = lazy(() => import("./Pages/Support"));
const Forgetpassword = lazy(() => import("./Pages/Auth/Forgetpassword"));
const Resetpassword = lazy(() => import("./Pages/Auth/Resetpassword"));
const Otpvalidation = lazy(() => import("./Pages/Auth/Otpvalidation"));
const OtpValidation2fa = lazy(() => import("./Pages/Auth/OtpValidation2fa"));
const Success = lazy(() => import("./Pages/Auth/Success"));
const HedgeFund = lazy(() => import("./Pages/HedgeFund"));
const Transaction = lazy(() => import("./Pages/Transaction"));
const Forex = lazy(() => import("./Pages/Forex"));
const Crypto = lazy(() => import("./Pages/Crypto"));
const Platform = lazy(() => import("./Pages/Platform"));
const Commodities = lazy(() => import("./Pages/Commodities"));
const AccountType = lazy(() => import("./Pages/AccountType"));
const LiveEvents = lazy(() => import("./Pages/LiveEvents"));
const Indices = lazy(() => import("./Pages/Indices"));
const Stock = lazy(() => import("./Pages/Stock"));
const PaymentMethod = lazy(() => import("./Pages/PaymentMethod"));
const BankTransfer = lazy(() => import("./Pages/BankTransfer"));
const UpiTransfer = lazy(() => import("./Pages/UpiTransfer"));
const GpayTransfer = lazy(() => import("./Pages/GpayTransfer"));

const P2pPage = lazy(() => import("./components/p2p/P2pPage"));
const Spot = lazy(() => import("./components/Spot/Spot"));
const Market = lazy(() => import("./Pages/Home/Market"));
const Kyc = lazy(() => import("./Pages/Kyc"));
const PostNewAd = lazy(() => import("./components/PostNewAd"));
const Myads = lazy(() => import("./Pages/Myads"));
const OpenOrders = lazy(() => import("./Pages/OpenOrders"));
const Orderdetails = lazy(() => import("./Pages/Orderdetails"));
const Deposit = lazy(() => import("./Pages/Deposit"));
const Withdraw = lazy(() => import("./Pages/Withdraw"));
const History = lazy(() => import("./Pages/History/History"));
const Privacy = lazy(() => import("./Pages/Privacy"));
const Terms_conditions = lazy(() => import("./Pages/Terms&conditions"));
const NotFound = lazy(() => import("./Pages/404/NotFound"));

const Chart = lazy(() => import("../src/components/Chart/Chart"));



const Layout = () => {
  const location = useLocation();
  const userToken = localStorage.getItem("crymadx");
  const currentRoute = Object.keys(routeMetadata).find(route =>
    location.pathname === route || location.pathname.startsWith(route)
  );
  const metadata = currentRoute ? routeMetadata[currentRoute] : {
    title: 'Page Not Found',
    description: 'The page you are looking for does not exist'
  };
  const hideHeaderFooterPaths = [
    "/login",
    "/register",
    "/reset_password",
    "/otp_validation",
    "/forget_password",
    "/register_successfull",
    "chart/:id",
    "/verify-ip",
  ];

  // const hideHeaderFooter = hideHeaderFooterPaths.includes(location.pathname) || location.pathname.startsWith("/chart/")
  // const isSpot = location.pathname.startsWith("/spot");
  const hideHeaderFooter = hideHeaderFooterPaths.includes(location.pathname) || location.pathname.startsWith("/chart/")
  const keywords = ["/spot", "/chart"];
  const isSpot = keywords.some(keyword => location.pathname.startsWith(keyword));

  const isHome =
    [
      "/",
      "/home",
      "/login",
      "/verify-ip",
      "/register",
      "/forget_password",
      "/otp_validation",
      "/reset_password",
      "/register_successfull",
      "/verify-ip"
    ].includes(location.pathname) || isSpot;

  return (
    <div className="flex flex-col min-h-screen">
      {/* <ToastContainer /> */}
      {!hideHeaderFooter && (
        <div className="fixed top-0 left-0 w-full z-50">
          <Header userToken={userToken} />
        </div>
      )}
      <div
        className={`flex-grow ${hideHeaderFooter ? "" : "bg-white dark:bg-rootBgColor pt-10"
          }`}
      >
        <div
          className={`${isHome
            ? ""
            : "px-4 xs:px-xs-px sm:px-sm-px md:px-md-px lg-xl:px-lg-xl-px xl:px-[150px] 2xl:px-[250px] 3xl:px-[350px] 4xl:px-[550px] 5xl:px-[800px] 6xl:px-[950px] 7xl:px-[1000px] 8xl:px-[1250px] 9xl:px-[1400px] 10xl:px-[1600px] 11xl:px-[2100px] 12xl:px-[3000px] xs:py-xs-py xs-sm:py-xs-sm-py sm:py-sm-py md:py-md-py lg:py-xl-py"
            }`}
        >
          <div className="hidden">
            <ThemeToggle />
          </div>
          <Suspense fallback={<div className="flex items-center justify-center h-screen w-full">
            <div className="loader" />
          </div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/market" element={<Market />} />
              <Route path="/spot/:coin" element={<Spot />} />
              <Route path="/chart/:id" element={<Chart />} />
              <Route path="/terms_conditions" element={<Terms_conditions />} />
              <Route path="/policy" element={<Privacy />} />
              <Route path="/verify-ip" element={<IPVerification />} />


              <Route element={<ProtectedRouter />}>
                <Route path="/login" element={
                  <GoogleReCaptchaProvider
                    reCaptchaKey={consts?.VITE_HCAPTCHA_SITEKEY}
                  >
                    <Login />
                  </GoogleReCaptchaProvider>} />
                <Route path="/otp_validation" element={<Otpvalidation />} />
                <Route path="/otp_validation2fa" element={<OtpValidation2fa />} />
                <Route path="/otp_validationEmail" element={<OtpValidationEmail />} />
                <Route path="/register" element={
                  <GoogleReCaptchaProvider
                    reCaptchaKey={consts?.VITE_HCAPTCHA_SITEKEY}
                  >
                    <Register />
                  </GoogleReCaptchaProvider>
                }
                />
                <Route path="/register/:referalCode" element={
                  <GoogleReCaptchaProvider
                    reCaptchaKey={consts?.VITE_HCAPTCHA_SITEKEY}
                  >
                    <Register />
                  </GoogleReCaptchaProvider>
                }
                />
                <Route path="/forget_password" element={<Forgetpassword />} />
                <Route path="/reset_password" element={<Resetpassword />} />
                <Route path="/register_successfull" element={<Success />} />
              </Route>


              <Route element={<ProtectedRouterLogin />}>

                <Route path="/profile" element={<Profile />} />
                <Route path="/forex" element={<Forex />} />
                <Route path="/crypto" element={<Crypto />} />
                <Route path="/platform" element={<Platform />} />
                <Route path="/commodities" element={<Commodities />} />
                <Route path="/indices" element={<Indices />} />
                <Route path="/stock" element={<Stock />} />
                <Route path="/p2p" element={<P2pPage />} />
                <Route path="/payment-method" element={<PaymentMethod />} />
                <Route path="/transaction" element={<Transaction />} />
                <Route path="/stake" element={<Stake />} />
                <Route path="/convert" element={<Convert />} />
                <Route path="/convert-history" element={<ConvertHistory />} />
                <Route path="/kyc" element={<Kyc />} />
                <Route path="/deposit" element={<Deposit />} />
                <Route path="/withdraw" element={<Withdraw />} />
                <Route path="/history" element={<History />} />
                <Route path="/wallet" element={<Wallet />} />
                <Route path="/notification" element={<Notification />} />
                <Route path="/support" element={<Support />} />
                <Route path="/bank-payment" element={<BankTransfer />} />
                <Route path="/upi" element={<UpiTransfer />} />
                <Route path="/gpay" element={<GpayTransfer />} />
                <Route path="/postnewad" element={<PostNewAd />} />
                <Route path="/myads" element={<Myads />} />
                <Route path="/openorders" element={< OpenOrders />} />
                <Route path="/order-details" element={<Orderdetails />} />
                <Route path="/account-type" element={<AccountType />} />
                <Route path="/hedge-fund" element={<HedgeFund />} />
                <Route path="/live-events" element={<LiveEvents />} />
                {/* <Route path="/order-history" element={<OrderHistory />} /> */}
                <Route path="/terms_condition" element={<Kyc_Terms_conditions />} />
              </Route>

              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </div>
      </div>
      <SearchPopup />
      <ScrollToTop />
      {!isSpot && !hideHeaderFooter && <Footer />}
      {/* {hideHeaderFooter&&(
        <div className="bg-white dark:bg-black">
      <div className="max-w-7xl mx-auto w-full bg-white dark:bg-black dark:text-white text-center text-sm py-4 rounded-b-2xl">
          Copyright ©Crymadx
        </div>
        </div>
        )} */}

      <AutoLogout />

      {hideHeaderFooter && !location.pathname.startsWith("/chart/") && (
        <AuthFooter />
      )}
    </div>
  );
};

export default function App() {
  return (
    <HelmetProvider>
      <Provider store={store}>
        <Router>
          <Layout />
        </Router>
      </Provider>
    </HelmetProvider>
  );
}
